<template>
	<div id="waveform" class="w-full h-32" />
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue'
import WaveSurfer from 'wavesurfer.js'

const props = defineProps(['recording'])
const wavesurfer = ref(null)

onMounted(() => {
	wavesurfer.value = WaveSurfer.create({
	    container: '#waveform',
	    barWidth: 3,
	    barHeight: 1,
	    barGap: null,
	    waveColor: '#433edb',
	    interact: false,
	    barRadius: 3,
	    backend: 'MediaElementWebAudio',
	    xhr: {
	        cache: "no-cache",
	        mode: "cors",
	        method: "GET",
	        credentials: "include",
	        headers: [
	            { key: "cache-control", value: "no-cache, no-store, max-age=0" },
	            { key: "pragma", value: "no-cache" }
	        ]
	    }
	})

	console.log(props.recording.previewUrl)
	wavesurfer.value.load(props.recording.previewUrl)

	console.log(wavesurfer.value)	
})



</script>